module.exports = __webpack_public_path__ + "img/D201608_2.78c029b5.jpg";